import {
  LOCATIONS_COLLECTION_ADD,
  LOCATIONS_COLLECTION_CLEAR,
  LOCATIONS_COLLECTION_DELETE,
  LOCATIONS_COLLECTION_GET,
  LOCATIONS_COLLECTION_UPDATE,
} from '../actions/actionTypes';

const initialState = [];

const locationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATIONS_COLLECTION_ADD:
      return [...state, action.location];
    case LOCATIONS_COLLECTION_UPDATE:
      return state.map((item) => {
        if (item.id === action.location.id) {
          return action.location;
        }
        return item;
      });
    case LOCATIONS_COLLECTION_DELETE:
      return state.filter((item) => item.id !== action.value);
    case LOCATIONS_COLLECTION_GET:
      return action.value;
    case LOCATIONS_COLLECTION_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default locationsReducer;
